<div class="mini-footer-container">
    <div class="content">
        <span class="title">
            Copyright © {{currentYear}} equalall. All Rights Reserved.
        </span>
        <span class="desc">
            equalall (Equal Aid for Equal Lives, Inc) is a California-registered 501(c)(3) nonprofit organization (EIN 93-3691588).
        </span>
    </div>
</div>